'use client';

export const catalogPromos: Record<
  number,
  { image: string; title: string; lines: string[]; productId: number }
> = {
  4: {
    image: '/storefront/catalog-promo-dinner-v2.webp',
    title: 'Ужин уже дома',
    lines: ['Ужин', 'уже дома'],
    productId: 100016,
  },
  14: {
    image: '/storefront/catalog-promo-han-v2.webp',
    title: 'План на вечер: Хан',
    lines: ['План на', 'вечер: Хан'],
    productId: 22,
  },
  5: {
    image: '/storefront/catalog-promo-family-v2.webp',
    title: 'Десерт и разговоры',
    lines: ['Десерт', 'и разговоры'],
    productId: 100147,
  },
};

type Props = {
  image: string;
  title: string;
  lines: string[];
  productName: string;
  onSelect: () => void;
};

export function CatalogPromoCard({ image, title, lines, productName, onSelect }: Props) {
  return (
    <button
      className="catalog-promo-card"
      onClick={onSelect}
      aria-label={`${title}. Подробнее: ${productName}`}
    >
      <img src={image} width={1122} height={1402} alt="" loading="lazy" decoding="async" />
      <span className="catalog-promo-copy" aria-hidden="true">
        <strong>
          {lines.map((line) => (
            <span key={line}>{line}</span>
          ))}
        </strong>
      </span>
    </button>
  );
}
